import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from '../router';

Vue.use(Vuex);

class Dealer {
  constructor(id, values) {
    this.id = id;

    this.code = values[3];
    this.name = values[4];
    this.streetAddress = values[5];
    this.city = values[8];
    this.state = values[9];
    this.country = values[10];
    this.postalCode = values[11];
    this.phone = values[12];
    this.salesEmail = values[15];
    this.website = values[17];
    this.stars = values[19];

    this.lat = values[29];
    this.lng = values[28];
  }
}

export default new Vuex.Store({
  state: {
    isCommercial: undefined,
    isAIMasking: undefined,

    sharableProducts: [],
    shellProject: undefined,
    renderProject: undefined,
    applyToLayer: null,
    currentLayer: undefined,
    currentView: undefined,
    currentRender: undefined,
    currentProduct: undefined,
    currentSavedDoor: undefined,
    designUrl: undefined,
    sharingEmail: false,
    sharingType: undefined,
    noWindows: false,
    noDealerQuotes: false,
    dealerID: undefined,
    dealerEmail: undefined,
    dealers: [],
    products: {},
    slides: {
      configurator: ['projects', 'products', 'summary'],
      projects: ['list', 'item'],
    },
    currentSlides: {
      configurator: 'products',
      projects: 'list',
    },

    specialCases: {
      sharingType: {
        dealer: 'dealer',
        friend: 'friend',
      },
      stepNames: {
        applyToLayers: 'Apply Design To',
        size: 'Size',
        savedDoors: 'My Saved Doors',
        product: 'Products',
        design: 'Design',
        style: 'Style',
        thermalConstruction: 'Thermal Requirements / Construction',
        color: 'Color',
        windows: 'Windows',
        glass: 'Glass',
        exteriorHardware: 'Exterior Hardware',
        // upgrades: 'Optional Upgrades',
      },
      sectionNames: {
        windowInserts: 'Window Inserts',
      },
      categoryNames: {
        position: 'Position',
        moreColors: 'More Colors',
        ralColors: 'RAL Powder Coat',
        // upgrades: 'Optional Upgrades',
      },
      productNames: {
        stampedShaker: 'Stamped Shaker',
        accentsWoodtones: 'Accents Woodtones',
        raisedPanel: 'Raised Panel',
        stampedCarriageHouse: 'Stamped Carriage House',
        flushPanel: 'Flush Panel',
        overlayRecessedPanel: 'Overlay Recessed Panel',
        aluminumFullView: 'Aluminum Full-View',
        overlayCarriageHouse: 'Overlay Carriage House',
        ribbedSteel: 'Ribbed Steel',
        insulatedSandwich: 'Insulated Sandwich',
      },
      /* multiSelect: {
        step: 'Optional Upgrades',
        reset: 'No Upgrades',
        done: 'Done',
      }, */
      info: {
        windowPosition: {
          trigger: 'hover',
          placement: 'bottom',
          content: 'Additional window placements available. Please contact your dealer for more details.',
        },
        /* upgradesPopover: {
          trigger: 'hover',
          placement: 'top',
          content: `
            White Appearance
            All hardware, including struts and track, is powder coated, creating a
            complete garage door system with a clean and finished look.

            Lifetime Package
            Extend your standard lifetime warranty to the entire door. This option provides upgraded
            hardware and springs and lifetime coverage for as long as you own your home.

            No Upgrades
            Clears all other selections and selects No Upgrades only
          `,
        },
        upgradesSelectionText: {
          content: 'Multiple options can be selected. Click "Done" once selections are made.',
        }, */
      },
      title: 'CHI | DoorVisions',
      disclaimer: 'These woodtones, colors, and door panels are to be used as an indication only. Some sizes not available in all models and configurations. Refer to your local C.H.I. Dealer for the exact look of your garage door and availability.',
      autoAdvance: {
        noWindows: 'no windows',
        section: 'window',
      },
      tabOptionsFilters: ({
        standardFrontColorOptions,
        accentFrontColorOptions,
        chiPowderCoatOptions,
        woodgrainPowderCoatOptions,
        ralColorOptions,
        mortonColorOptions,
        customFrontColorOptions,
        // exteriorHardwareOptions,
        // upgradeOptions,
      }) => ({
        'Solid Colors': option => standardFrontColorOptions && standardFrontColorOptions
          .find(color => color.displayName === option.name),
        'Accents Woodtones': option => accentFrontColorOptions && accentFrontColorOptions
          .find(color => color.displayName === option.name),
        'CHI Powder Coat': option => chiPowderCoatOptions && chiPowderCoatOptions
          .find(color => color.displayName === option.name),
        'Woodgrain Powder Coat': option => woodgrainPowderCoatOptions && woodgrainPowderCoatOptions
          .find(color => color.displayName === option.name),
        'RAL Powder Coat': option => ralColorOptions && ralColorOptions
          .find(color => color.displayName === option.name),
        'Morton Powder Coat': option => mortonColorOptions && mortonColorOptions
          .find(color => color.displayName === option.name),
        'Custom Colors': option => customFrontColorOptions && customFrontColorOptions
          .find(color => color.displayName === option.name),
        Woodtones: option => customFrontColorOptions && customFrontColorOptions
          .find(color => color.displayName === option.name),
        Wood: option => standardFrontColorOptions && standardFrontColorOptions
          .find(color => color.displayName === option.name),
        Shoreline: option => standardFrontColorOptions && standardFrontColorOptions
          .find(color => color.displayName === option.name),
        /*
        Handles: option => exteriorHardwareOptions && exteriorHardwareOptions
          .find(hardware => hardware.name === option.name),
        Hinges: option => exteriorHardwareOptions && exteriorHardwareOptions
          .find(hardware => hardware.name === option.name),
        Upgrades: option => upgradeOptions && upgradeOptions
          .find(upgrade => upgrade.name === option.name), */
      }),
    },
  },
  getters: {
    isHub() {
      return router.currentRoute.query.hub !== undefined;
    },
    isConfigurator() {
      return router.currentRoute.query.configurator !== undefined;
    },
    isCommercial(state) {
      return state.isCommercial === undefined
        ? router.currentRoute.query.products === 'commercial'
        : state.isCommercial;
    },
    isAIMasking(state) {
      return state.isAIMasking === undefined
        ? true
        : state.isAIMasking;
    },
    hubDefaultWidth() {
      return router.currentRoute.query.defaultWidth;
    },
    hubDefaultHeight() {
      return router.currentRoute.query.defaultHeight;
    },
    applyToLayers(state) {
      return state.shellProject ? state.shellProject.layers : [];
    },
    currentProject(state) {
      let currentProject = null;
      if (state.renderProject) {
        // clone it for non-destructive extending/altering
        currentProject = state.renderProject.clone();

        // manually maintain certain (clone-reset/lost) properties
        currentProject.loaded = state.renderProject.loaded;
        currentProject.renderSrc = state.renderProject.renderSrc;
        let averagePpf = 32;
        // set project ppf based on first layer size in renderProject
        if (state.currentLayer &&
          state.currentLayer.physicalWidth &&
          state.currentLayer.physicalHeight &&
          state.currentLayer.perspective) {
          averagePpf =
            window.Renoworks.Util.calculatePpf(
              state.currentLayer.perspective.points,
              state.currentLayer.physicalWidth,
              state.currentLayer.physicalHeight);
        }
        // set current ppf for rendering the project(s)
        currentProject.ppf = Math.round(averagePpf);

        // clone/create 'merged' layers
        if (state.shellProject) {
          // copy over any existing shell layers (e.g. for recently uploaded projects)
          if (!state.renderProject.layers.length) {
            currentProject.layers = state.shellProject.layers;
          } else {
            // 'merge' shell layers into/onto masked layers using rudimentary business logic
            currentProject.layers = state.renderProject.layers
              // only keep door layers
              .filter(layer => layer.layerType === 'RWDoor')
              // pluck shellProject layer data into existing layers
              .map((layer, i) => {
                const wrappedLayerIndex = i % state.shellProject.layers.length;
                const shellLayer = state.shellProject.layers[wrappedLayerIndex];
                layer.product = shellLayer.product
                  || (state.currentProduct && state.currentProduct.clone());
                layer.physicalWidth = layer.physicalWidth || shellLayer.physicalWidth;
                layer.physicalHeight = layer.physicalHeight || shellLayer.physicalHeight;
                layer.doorShape = layer.doorShape || shellLayer.doorShape;
                return layer;
              });
          }
        }

        // make immutable (since currentProject is read-only)
        // writes should go directly to render or shell project, as appropriate
        Object.freeze(currentProject);
      }
      return currentProject;
    },
    currentProduct(state) {
      return (state.currentLayer && state.currentLayer.product)
        || state.currentProduct;
    },
    getSlideIndex: state => (slide) => {
      const [component, name] = slide.split('/');
      const slides = state.slides[component];
      return slides ? slides.indexOf(name || state.currentSlides[component]) : -1;
    },
    currentRender(state) {
      return state.currentRender;
    },
    currentDealer(state) {
      return state.dealers
        && state.dealerID
        && state.dealers.find(({ id }) => `${id}` === `${state.dealerID}`);
    },
  },
  mutations: {
    setShellProject(state, project) {
      state.shellProject = project;
    },
    setRenderProject(state, project) {
      state.renderProject = project;
    },
    setApplyToLayer(state, layer) {
      state.applyToLayer = layer;
    },
    setCurrentLayer(state, layer) {
      state.currentLayer = layer;
    },
    setCurrentView(state, view) {
      state.currentView = view;
    },
    setCurrentRender(state, render) {
      state.currentRender = render;
    },
    setCurrentProduct(state, product) {
      if (state.currentLayer && state.currentLayer.product) {
        state.currentLayer.product = product;
      }
      state.currentProduct = product;
      state.products[product.name] = product;
    },
    setCurrentSavedDoor(state, door) {
      state.currentSavedDoor = door;
    },
    setCurrentSlide(state, slide) {
      const slides = Array.isArray(slide) ? slide : [slide];
      slides.forEach((s) => {
        const [component, name] = s.split('/');
        state.currentSlides[component] = name;
      });
    },
    setSharingEmail(state, sharingEmail) {
      state.sharingEmail = sharingEmail;
    },
    setSharingType(state, sharingType) {
      if (sharingType === state.specialCases.sharingType.dealer ||
        sharingType === state.specialCases.sharingType.friend) {
        state.sharingType = sharingType;
      }
    },
    setDesignUrl(state, url) {
      state.designUrl = url;
    },
    setNoWindows(state, noWindows) {
      state.noWindows = noWindows;
    },
    setNoDealerQuotes(state, noDealerQuotes) {
      state.noDealerQuotes = noDealerQuotes;
    },
    setDealerID(state, dealerID) {
      state.dealerID = dealerID;
    },
    setDealerEmail(state, email) {
      state.dealerEmail = email;
    },
    setDealers(state, dealers) {
      state.dealers = dealers;
    },
    setCommercial(state, isCommercial) {
      state.isCommercial = isCommercial;

      const { products, ...query } = router.currentRoute.query;
      if (isCommercial) {
        router.replace({ ...router.currentRoute, query: { ...query, products: 'commercial' } });
      } else {
        router.replace({ ...router.currentRoute, query });
      }
    },
    setAIMasking(state, isAIMasking) {
      state.isAIMasking = isAIMasking;
    },
  },
  actions: {
    setCurrentSlide({ commit }, slide) {
      commit('setCurrentSlide', slide);
    },
    async getDealers({ state, commit }) {
      if (state.dealers && state.dealers.length) return;

      try {
        const res = await axios.get('https://api.hubapi.com/hubdb/api/v1/tables/460287/rows?portalId=2029938&limit=1500');
        const dealers = res.data.objects.map(d => new Dealer(d.id, d.values));
        commit('setDealers', dealers);
      } catch (err) {
        console.warn('Failed to fetch dealers from API', err); // eslint-disable-line no-console
        commit('setDealers', []);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js